import HasLabel from './HasLabel';
import { Team } from './Team';

export interface User {
    userName: string;
    initials: string;
    infinitrakApiKey: string;
    firstName: string;
    lastName: string;
    npiNumber: string;
    isRemote: boolean;
    teams: Team[];
    licenses: UserComplianceLicense[];
    /**
     * False for a user who has been taken off the active roster: they are hidden from assignment
     * dropdowns and listed under the Users page's Inactive view. Not an access control -- signing
     * in reactivates them.
     */
    active: boolean;
    /**
     * When the user was last deactivated, as the UTC string the API serializes. Cleared on
     * reactivation; the trail lives in history.
     */
    deactivatedDate?: string;
    /** Who last deactivated the user. Cleared on reactivation. */
    deactivatedBy?: string;
    /**
     * The user's earliest recorded sign-in, as the UTC string the API serializes (no zone marker,
     * so parse it with moment.utc()). Derived server-side from the login history, never written by
     * the client.
     *
     * Undefined or null means there is no login row yet, which the welcome gate reads as "the
     * first login is happening now": the very first sign-in returns null because the history row
     * is written after the response.
     */
    firstLoginDate?: string | null;
}

export class User extends HasLabel {
    constructor(obj?: User) {
        super();
        this.userName = "";
        this.active = true;
        if (obj) {
            Object.assign(this, obj);
        }
    }
    toString(): string {
        if (this.lastName && this.firstName)
            return `${this.firstName} ${this.lastName}`;
        return this.userName;
    }
}

export interface UserComplianceLicense {
    active: boolean;
    state: string;
    licenseNumber: string;
    startDate?: Date;
    endDate?: Date;
}